



















import Vue from "vue";

export default Vue.extend({
  methods: {
    isDefaultSlot(name: string) {
      return name === "";
    }
  },
  computed: {
    tableHeaders() {
      return ["Name", "Description"];
    }
  },
  props: {
    slots: Array
  }
});
